export default __webpack_public_path__ + "static/media/h6.58edcdd5.jpg";